module.exports = "<div class=\"form_loader\">\n  <div class=\"data_loader\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/app/components/common/loader/loader.component.html
// module id = ../../../../../src/app/components/common/loader/loader.component.html
// module chunks = main